<template>
  <div class="header-content">
    <img class="header-img" src="@/assets/page1-bg.png">
    <img class="header-phone" src="@/assets/page1-bg-phone.png">
    <img class="logo" src="@/assets/logo.png" alt="logo">
    <!-- <div class="title-bg"></div> -->
    <div class="title-text">My Hero Academia</div>
    <div class="title-text1">Battle Arena</div>
    <div class="content">
      <div class="content-wrapper">
        <p>My Hero Academia 3D RPG is here! Enroll at U.A. High, master your Quirk, and battle alongside Deku, Bakugo, and All Might in cinematic combat! PLUS ULTRA!</p>
        <p>1.Authentic Anime Combat</p>
        <p>Execute signature moves of all heroes with flawless frame-rate animations and exquisitely crafted battle stages.</p>
        <p>2.Build Your Hero Agency</p>
        <p>Recruit multiple powerful heroes, develop their unique abilities, and assemble your ultimate dream team.</p>
        <p>3.Hero Rankings</p>
        <p>Climb real-time PVP leaderboards during limited-time seasons to earn exclusive generous rewards.</p>
        <p>4.Immersive Game Experience</p>
        <p>Relive classic moments from the series through stunning visuals and all-new boss raid events.</p>
      </div>
    </div>
  </div>
</template>
<script>
import config from "../config.js";
export default {
  data() {
    return {
      config,
    }
  }
}
</script>
<style lang="scss" scoped>
.header-content{
  position: relative;
  .header-img{
    width: 100%;
    // height: 1080px;
  }
  .logo{
    position: absolute;
    top: 20px;
    left: 100px;
    width: 160px;
    height: 160px;
  }
  .header-phone{
    display: none;
  }
  .title-bg{
    position: absolute;
    top: 180px;
    left: calc(50% - 340px);
    width: 680px;
    height: 254px;
    background: url(../assets/title-bg.png);
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    font-size: 120px;
    font-family: titleFont;
    padding-top: 20px;
    text-shadow: 4px 4px 8px rgba(255, 255, 255, 1);
  }
  .title-text{
    font-size: 100px;
    font-family: titleFont;
    position: absolute;
    top: 260px;
    left: calc(50% - 500px);
    color: #fff;
    text-shadow: 4px 4px 10px rgb(23, 123, 236);
  }
  .title-text1{
    font-size: 100px;
    font-family: titleFont;
    position: absolute;
    top: 360px;
    left: calc(50% - 380px);
    color: #fff;
    text-shadow: 4px 4px 10px rgb(23, 123, 236);
  }
  .content{
    position: absolute;
    padding: 36px;
    top: 560px;
    left: calc(50% - 600px);
    width: 1200px;
    height: 680px;
    background: url(../assets/content-bg.png);
    background-size: 100% 100%;
    font-size: 30px;
    .content-wrapper{
      max-height: 660px;
      overflow: auto;
      p{
        margin-bottom: 20px;
      }
    }
  }
}
@media screen and (max-width: 1600px) {
  .header-content{
    .title-bg{
      top: 120px;
    }
    .content{
      top: 400px;
    }
  }
}
@media screen and (max-width: 768px) {
  .header-content{
    .header-img{
      display: none;
    }
    .header-phone{
      display: block;
      width: 100%;
      height: 870px;
    }
    .logo{
      top: 20px;
      left: 20px;
      width: 120px;
      height: 120px;
    }
    .title-bg{
      top: 10px;
      left: calc(50% - 170px);
      width: 340px;
      height: 127px;
      font-size: 70px;
      padding-top: 0;
    }
    .title-text{
      font-size: 38px;
      font-family: titleFont;
      position: absolute;
      top: 120px;
      left: calc(50% - 150px);
    }
    .title-text1{
      font-size: 38px;
      font-family: titleFont;
      position: absolute;
      top: 180px;
      left: calc(50% - 120px);
    }
    .content{
      top: 320px;
      padding: 36px;
      left: calc(50% - 278px);
      width: 556px;
      height: 430px;
      max-height: 430px;
      overflow: auto;
      background: url(../assets/content-phone-bg.png);
      background-size: 100% 100%;
      .content-wrapper{
        max-height: 420px;
        overflow: auto;
      }
    }
  }
}
</style>